<template>
  <div class="row nav-padding">
        <div class="d-flex align-items-center justify-content-between px-3 pt-3">
            <div>
                <div v-if="companies.length">
                    <span class="_700">Results:</span> {{ companies.length }}
                </div>
            </div>

            <div class="d-flex align-items-center">
                <div class="mr-2">
                    <el-select v-model="selected_integration"
                            filterable
                            placeholder="Select an integration"
                            @change="handleIntegrationChange">
                        <el-option v-for="(integration, index) in integrations"
                                :key="index"
                                :label="integration.label"
                                :value="integration.value">
                            <div class="lh-1p4 py-2 px-3">
                                <h6 class="mb-0">{{ integration.label }}</h6>
                            </div>
                        </el-option>
                    </el-select>
                </div>

                <div>
                    <el-button @click="handleSearch"
                                type="success">Search</el-button>
                </div>
            </div>
        </div>

        <div class="w-100 pt-5">
            <div
                v-if="companies.length"
                class="p-3">
                <el-table
                    :data="companies"
                    style="width: 100%">
                    <el-table-column
                        prop="id"
                        label="ID">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="Company Name">
                    </el-table-column>
                </el-table>
            </div>

            <div v-else
                class="h-100 d-flex align-items-center">
                <div v-if="searching"
                    class="w-100">
                    <h3 class="text-center">Loading...</h3>
                </div>

                <div v-else-if="no_results"
                    class="w-100">
                    <h3 class="text-center">No results.</h3>
                </div>

                <div v-else
                    class="w-100 search-resource-text">
                    <div class="text-center">
                        <i class="fa fa-search"></i>
                        <p class="mb-0">Search integrations</p>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            companies: [],
            integrations: [
                {
                    label: 'Facebook',
                    value: 'facebook'
                },
                {
                    label: 'Zapier',
                    value: 'zapier'
                },
                {
                    label: 'Pipedrive',
                    value: 'pipedrive'
                },
                {
                    label: 'Hubspot',
                    value: 'hubspot'
                },
                {
                    label: 'Slack',
                    value: 'slack'
                },
                {
                    label: 'Webhook',
                    value: 'webhook'
                },
                {
                    label: 'Stripe',
                    value: 'stripe'
                },
                {
                    label: 'Zoho',
                    value: 'zoho'
                },
                {
                    label: 'SendGrid',
                    value: 'sendgrid'
                },
                {
                    label: 'Mailgun',
                    value: 'mailgun'
                },
                {
                    label: 'Guesty',
                    value: 'guesty'
                },
                {
                    label: 'Gong',
                    value: 'gong'
                },
                {
                    label: 'HighLevel',
                    value: 'gohighlevel'
                },
                {
                    label: 'Salesforce',
                    value: 'salesforce'
                },
                {
                    label: 'Custom Link Builder',
                    value: 'custom_link_builder'
                }
            ],
            selected_integration: '',
            no_results: false,
            searching: false
        }
    },

    methods: {
        handleIntegrationChange(value) {
            this.selected_integration = value
        },

        handleSearch() {
            if (!this.selected_integration) {
                this.$notify.error({
                    title: 'Error',
                    message: 'Please select an integration'
                })
            }

            this.searching = true

            axios.get(`/api/admin/company?integration=${this.selected_integration}`)
                .then(response => {
                    const { data: companies } = response
                    if (companies.length == 0) {
                        this.no_results = true
                    } else {
                        this.no_results = false
                    }
                    this.companies = companies
                })
                .catch(error => {
                    console.error({
                        error
                    })

                    this.$notify.error({
                        title: 'Error',
                        message: error.message
                    })
                })
                .finally(() => this.searching = false)
        }
    }
}
</script>

<style>

</style>
